<template>
  <div>
    <ConfigListItem
      label="Horímetro"
      :value="strValue"
      :date="maxUpdatedAt"
      :login="maxUpdatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog" :max-width="800">
      <v-card>
        <ODialogBar title="Origem do Horímetro" @close="dismiss" />
        <v-card-text class="pa-6">
          <div class="d-flex align-start">
            <OVerticalTabs
              class="mr-6"
              v-model="clonedValues.horoSource"
              :tabs="[
                { value: 'sensor', text: 'Sensor' },
                { value: 'can', text: 'CAN' }
              ]"
            />
            <v-tabs-items class="flex-grow-1" v-model="clonedValues.horoSource">
              <div class="px-4" v-if="clonedValues.horoSource == null">
                Escolha um valor da lista ao lado.
              </div>

              <v-tab-item value="sensor" class="px-4">
                Funcionalidade padrão
              </v-tab-item>

              <v-tab-item value="can" class="px-4">
                <SelectCANVariable
                  :canDictId="canDictId"
                  v-model="clonedValues.horoCanVariable"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import ConfigListItem from './ConfigListItem.vue'
import {
  mostRecentlyUpdated,
  getCfg,
  getManyCfgs
} from './config-utils.js'
import OVerticalTabs from './OVerticalTabs.vue'
import SelectCANVariable from './SelectCANVariable.vue'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs) {
  let cfgs = getManyCfgs(allConfigs, 'horoSource', 'horoCanVariable')
  switch (cfgs.horoSource) {
    case 'sensor': {
      return `Sensor`
    }
    case 'can': {
      let y = cfgs.horoCanVariable
      return `CAN variable=${y && y.code}`
    }
    default:
      return '???'
  }
}

export function copyValue(allConfigs) {
  return getManyCfgs(allConfigs, 'horoSource', 'horoCanVariable')
}

export default {
  components: { ConfigListItem, OVerticalTabs, SelectCANVariable },
  props: {
    vehicle: { required: true },
    allConfigs: { required: true }
  },
  data() {
    return {
      clonedValues: { horoSource: 'sensor' }
    }
  },
  computed: {
    canDictId() {
      return getCfg(this.allConfigs, 'canDictId')
    },
    strValue() {
      return displayValue(this.allConfigs)
    },
    mostRecent() {
      return mostRecentlyUpdated(
        this.allConfigs,
        'horoSource',
        'horoCanVariable'
      )
    },
    maxUpdatedAt() {
      return this.mostRecent && this.mostRecent.updatedAt
    },
    maxUpdatedBy() {
      return this.mostRecent && this.mostRecent.updatedBy
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.clonedValues = getManyCfgs(
        this.allConfigs,
        'horoSource',
        'horoCanVariable'
      )
      return this.$refs.dialog.$open()
    },
    async save() {
      const payload = this.clonedValues
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style></style>
